import type veEn from "./ve.en";

// محرّر القالب المرئي (specs 20).
const veAr: Record<keyof typeof veEn, string> = {
  "ve.title": "محرّر القالب",
  "ve.back": "العودة إلى القوالب",
  "ve.save": "حفظ",
  "ve.saved": "تم الحفظ — أصبحت تغييراتك فعّالة في هذا القالب",
  "ve.preview": "معاينة المتجر",
  "ve.device": "حجم المعاينة",
  "ve.device.desktop": "حاسوب",
  "ve.device.tablet": "جهاز لوحي",
  "ve.device.mobile": "جوال",
  "ve.device.full": "عرض كامل",
  "ve.preview_language": "لغة المعاينة",
  "ve.undo": "تراجع",
  "ve.redo": "إعادة",
  "ve.inspector": "التحديد من الصفحة",
  "ve.more": "المزيد",
  "ve.edit_code": "تعديل الشيفرة",
  "ve.share_preview": "نسخ رابط المعاينة (7 أيام)",
  "ve.share_copied": "تم نسخ رابط المعاينة، وهو صالح لمدة 7 أيام.",
  "ve.open_preview": "فتح المعاينة في تبويب جديد",
  "ve.discard": "تجاهل التغييرات",
  "ve.discard_title": "تجاهل التغييرات غير المحفوظة؟",
  "ve.discard_body": "سيُحذف كل ما تغيّر منذ آخر حفظ، لكل من يحرّر هذا القالب.",
  "ve.save_before_publish": "احفظ تغييراتك قبل النشر.",
  "ve.stale": "تغيّرت ملفات القالب منذ بدء هذه التغييرات غير المحفوظة (من محرّر الشيفرة أو حفظ آخر). راجع المعاينة قبل الحفظ.",
  "ve.changed_by": "غيّر {who} هذا القالب",
  "ve.tab.sections": "الأقسام",
  "ve.tab.settings": "إعدادات القالب",
  "ve.template": "القالب",
  "ve.custom_page_note": "الصفحات المخصّصة ملفات شيفرة. عاينها هنا، وعدّل تخطيطها في محرّر الشيفرة ومحتواها من واجهة المتجر › الصفحات.",
  "ve.liquid_template_note": "هذا القالب ملف Liquid، فلا أقسام فيه لترتيبها. عاينه هنا أو عدّله في محرّر الشيفرة.",
  "ve.settings_panel": "الإعدادات",
  "ve.no_settings": "لا توجد إعدادات هنا.",
  "ve.feature_off": "الميزة متوقفة",
  "ve.duplicate": "نسخ",
  "ve.remove": "إزالة",
  "ve.remove_static_title": "إزالة هذا القسم؟",
  "ve.remove_static_body": "لا يمكن إضافة هذا القسم مجدداً من مكتبة الأقسام. يمكنك التراجع لاستعادته قبل الحفظ.",
  "ve.add_section": "إضافة قسم",
  "ve.add_block": "إضافة كتلة",
  "ve.add_named": "إضافة {name}",
  "ve.search_sections": "البحث في الأقسام",
  "ve.no_sections": "لا يمكن إضافة أقسام أخرى هنا.",
  "ve.show": "إظهار",
  "ve.hide": "إخفاء",
  "ve.expand": "إظهار الكتل",
  "ve.collapse": "إخفاء الكتل",
  "ve.drag": "سحب {name}",
  "ve.create_template": "إنشاء قالب",
  "ve.search_templates": "البحث في القوالب",
  "ve.preview_only": "معاينة فقط",
  "ve.custom_page": "صفحة مخصّصة",
  "ve.template_for": "قالب لـ",
  "ve.template_name": "الاسم",
  "ve.template_name_hint": "أحرف إنجليزية صغيرة وأرقام و - و _. اربطه بالمنتجات أو المجموعات أو الصفحات من صفحاتها.",
  "ve.based_on": "البدء من",
  "ve.default_template": "القالب الافتراضي",
  "ve.tpl.index": "الصفحة الرئيسية",
  "ve.tpl.product": "المنتجات",
  "ve.tpl.collection": "المجموعات",
  "ve.tpl.list-collections": "قائمة المجموعات",
  "ve.tpl.page": "الصفحات",
  "ve.tpl.blog": "المدوّنات",
  "ve.tpl.article": "المقالات",
  "ve.tpl.cart": "السلة",
  "ve.tpl.search": "البحث",
  "ve.tpl.404": "صفحة غير موجودة",
  "ve.tpl.password": "كلمة المرور",
  "ve.code_setting_locked": "يمكن تغيير هذا فقط لمن يملك صلاحية تعديل الشيفرة.",
  "ve.align.left": "يسار",
  "ve.align.center": "وسط",
  "ve.align.right": "يمين",
  "ve.low_contrast": "تباين منخفض ({ratio}:1). اجعله 4.5:1 على الأقل ليبقى النص واضحاً.",
  "ve.link_choose": "اختر رابطاً",
  "ve.link_title": "رابط إلى",
  "ve.clear": "مسح",
  "ve.link_unsafe": "استخدم رابطاً يبدأ بـ https:// أو mailto: أو tel: أو /.",
  "ve.use_link": "استخدام هذا الرابط",
  "ve.anchor_hint": "رابط إلى قسم في الصفحة نفسها حسب معرّفه.",
  "ve.search": "بحث",
  "ve.no_results": "لا توجد نتائج.",
  "ve.linkcat.fixed": "صفحات المتجر",
  "ve.linkcat.product": "المنتجات",
  "ve.linkcat.collection": "المجموعات",
  "ve.linkcat.page": "الصفحات",
  "ve.linkcat.custom_page": "صفحات مخصّصة",
  "ve.linkcat.blog": "المدوّنات",
  "ve.linkcat.article": "المقالات",
  "ve.linkcat.policy": "السياسات",
  "ve.linkcat.url": "عنوان ويب",
  "ve.linkcat.anchor": "قسم في هذه الصفحة",
  "ve.link.home": "الصفحة الرئيسية",
  "ve.link.catalog": "كل المنتجات",
  "ve.link.collections": "كل المجموعات",
  "ve.link.search": "البحث",
  "ve.link.cart": "السلة",
  "ve.link.account": "حساب العميل",
  "ve.link.product": "منتج",
  "ve.link.collection": "مجموعة",
  "ve.link.page": "صفحة",
  "ve.link.blog": "مدوّنة",
  "ve.link.article": "مقال",
  "ve.link.policy": "سياسة",
  "ve.link.custom_page": "صفحة مخصّصة",
  "ve.link.anchor": "قسم",
  "ve.link.url": "عنوان ويب",
  "ve.pick.product": "اختر منتجاً",
  "ve.pick.collection": "اختر مجموعة",
  "ve.pick.blog": "اختر مدوّنة",
  "ve.pick.page": "اختر صفحة",
  "ve.pick.article": "اختر مقالاً",
  "ve.none": "بدون",
  "ve.file_choose": "اختر ملفاً",
  "ve.change": "تغيير",
  "ve.images": "الصور",
  "ve.videos": "الفيديو",
  "ve.upload": "رفع",
  "ve.no_files": "لا توجد ملفات بعد. ارفع ملفاً.",
};
export default veAr;
